/*
config: {id: string, pagination: {perPage: int, totalEntries: int, chooseResultsPerPage: bool, resultsOptions: array of ints}, emptyMessage: string}
table: array of data
header: [
      {
        name: string,
        sortBy: string,
        width: integer,
        extraHeaderClasses: string,
        value: string (for non transcluded mode),
        extraBodyClasses: string (for non transcluded mode)
      }
    ]
}
note: if sortBy is not set on any columns in the header, sort will be disabled on the table
*/

var ctrl = function ($scope, $state, $stateParams) {
  $scope.getVal = function (row, col) {
    return _.get(row, col.value);
  };

  var refreshState = function (changes) {
    var newParams = angular.copy($stateParams);
    _.extend(newParams, changes);
    $state.go(".", newParams);
  };

  function updatePaginationConfig(paginationConfig) {
    $scope.resultsPerPage = parseInt(paginationConfig.perPage);

    $scope.pagination = {
      perPage: $scope.resultsPerPage,
      page: Number($stateParams.page || 1),
      totalEntries: parseInt(paginationConfig.totalEntries),
      chooseResultsPerPage: paginationConfig.chooseResultsPerPage || false,
      resultsOptions: paginationConfig.resultsOptions,
      goToPage:
        paginationConfig.goToPage ||
        function (n) {
          refreshState({ page: n });
        },
    };
  }

  if (!$scope.pagination && $scope.config.pagination) {
    updatePaginationConfig($scope.config.pagination);
  }

  if (
    !$scope.sortFilter &&
    _.some($scope.header, function (x) {
      return x.sortBy;
    })
  ) {
    $scope.sortFilter = {
      type: null,
      direction: null,
      sortCallBack: function (sortObj) {
        if (sortObj.order) {
          refreshState({ order: sortObj.order, direction: sortObj.direction, page: null });
        }
      },
    };
  }

  var setupSortFilter = function () {
    if ($stateParams.order && $scope.sortFilter) {
      $scope.sortFilter.type = $stateParams.order;
      $scope.sortFilter.direction = $stateParams.direction ? $stateParams.direction : "ASC";
    }
  };
  setupSortFilter();

  $scope.updateResultsPerPage = function (resultsPerPage) {
    $scope.resultsPerPage = resultsPerPage;
    refreshState({ per_page: $scope.resultsPerPage });
  };

  $scope.$on("updateResultsPerPage", function (event) {
    $scope.updateResultsPerPage(event.targetScope.resultsPerPage);
  });

  $scope.$watch("config", function (newValue, oldValue) {
    if (!angular.equals(newValue, oldValue)) {
      updatePaginationConfig(newValue.pagination);
    }
  });

  $scope.selectAllStatus = { checked: false };

  if ($scope.selectable) {
    $scope.$watch(
      "selectable",
      function (v) {
        if (!$scope.table) {
          return;
        }
        let tlength = $scope.table.length;
        $scope.selectAllStatus.checked = Object.keys(v).filter(k => v[k]).length == tlength;
      },
      true,
    );
  }
};

ctrl.$inject = ["$scope", "$state", "$stateParams"];

tiz.controller("proviTableCtrl", ctrl);
tiz.directive("proviTable", function () {
  return {
    scope: {
      table: "=",
      header: "=",
      config: "=?",
      tableName: "@?",
      pagination: "=?",
      sortFilter: "=?",
      selectable: "=?",
      selectAllCallback: "&?",
    },
    templateUrl: require("../templates/provi_table/table.html"),
    controller: "proviTableCtrl",
    transclude: {
      tableHeader: "?tableHeader",
      tableBody: "?tableBody",
    },
  };
});
